import pkg from '../package.json';
import { PLUGIN_NAME } from './constants';
import { setPluginConfig } from './config';

export { default as AddressLookup } from './components/AddressLookup';
export { default as useAddressSearch } from './hooks/useAddressSearch';
export { default as normaliseAddress } from './normalise-address';
export { getPluginConfig as getAddressLookupConfig } from './config';

export default async function load(app, options = {}) {
  // Loqate key and default country. See config.js.
  setPluginConfig(options);

  return {
    name: PLUGIN_NAME,
    version: pkg.version
  };
}

load.pluginName = PLUGIN_NAME;
